"use client";

import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CookiesAndTrackingTechnologies() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const cookieCategories = [{
    id: 1,
    title: "Essential Cookies",
    description: "These cookies are strictly necessary for the website to function properly. They enable core functionality such as security, network management, and accessibility. You cannot opt out of these cookies as they are required for the site to work."
  }, {
    id: 2,
    title: "Analytics Cookies",
    description: "Analytics cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This data helps us improve our website's performance and user experience."
  }, {
    id: 3,
    title: "Marketing Cookies",
    description: "Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for individual users, thereby creating value for publishers and third-party advertisers."
  }, {
    id: 4,
    title: "Preference Cookies",
    description: "Preference cookies enable a website to remember information that changes the way the website behaves or looks, such as your preferred language or the region that you are in."
  }];
  return;
}